<template>
    <div class="col-lg-5 col-md-12 box-col-5">
        <div class="card o-hidden">
          <div class="card-header pb-0">
            <h3>Total Earning</h3>
          </div>
          <div class="bar-chart-widget">
            <div class="top-content bg-primary"></div>
            <div class="bottom-content card-body">
              <div class="row">
                <div class="col-12">
                  <div id="chart-widget5"> 
                    <apexchart height="350" :options="earning.options" :series="earning.series" ></apexchart>
                  </div>
                </div>
              </div>
              <div class="row text-center total-earning">
                <div class="col-4 b-r-light">
                  <div><span class="font-primary">12%<i class="icon-angle-up f-12 ms-1"></i></span><span class="text-muted block-bottom">Year</span>
                    <h2 class="num m-0"><span class="counter color-bottom">3659</span>M</h2>
                  </div>
                </div>
                <div class="col-4 b-r-light">
                  <div><span class="font-primary">15%<i class="icon-angle-up f-12 ms-1"></i></span><span class="text-muted block-bottom">Month</span>
                    <h2 class="num m-0"><span class="counter color-bottom">698</span>M</h2>
                  </div>
                </div>
                <div class="col-4">
                  <div><span class="font-primary">34%<i class="icon-angle-up f-12 ms-1"></i></span><span class="text-muted block-bottom">Today</span>
                    <h2 class="num m-0"><span class="counter color-bottom">9361</span>M</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'

export default{
    name:'earningPage',
    data(){
        return{
            earning: wcharts.earning
        }
    }
}
</script>